/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubscriptionStationsPagedList } from '../../models/subscription-stations-paged-list';

export interface GetStationsOfSubscription$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * Ifs station has transaction
 */
  onlyWithTransactions?: boolean;
}

export function getStationsOfSubscription(http: HttpClient, rootUrl: string, params: GetStationsOfSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionStationsPagedList>> {
  const rb = new RequestBuilder(rootUrl, getStationsOfSubscription.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('onlyWithTransactions', params.onlyWithTransactions, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubscriptionStationsPagedList>;
    })
  );
}

getStationsOfSubscription.PATH = '/subscriptions/{uid}/stations';
